<template>
    <v-card>
        <v-toolbar v-if="computedGradingTable" dark flat dense color="secondary">
            <v-spacer />
            <v-toolbar-items>
                <TaxonomyTable :isCourse="true" />
                <CourseAdminUser :isAdmin="true" :value="value" />
                <CourseAdminUser :isAdmin="false" :value="value" />
                <AddUpdateCourse :type="operationType" />
            </v-toolbar-items>
        </v-toolbar>
        <v-sheet :class="cardStyle" @click="selectCard" v-if="picture !== ''" color="grey lighten-3">
            <ImageLoader :src="picture" :ratio="3.55" :contain="false" />
        </v-sheet>
        <v-tabs v-model="modalActive" show-arrows mandatory>
            <v-tab key="INFO">{{ computedTabTitle }}</v-tab>
            <v-tab key="MATERIAL" :disabled="!hasMaterial">{{ $t('Material') }}</v-tab>
            <v-tab key="CONTENT" :disabled="!hasContentLinks">{{ $t('Content Links') }}</v-tab>
        </v-tabs>
        <v-card :class="cardStyle" @click="selectCard" height="100%">
            <v-container>
                <v-row>
                    <v-col :cols="12">
                        <v-tabs-items v-model="modalActive" touchless>
                            <v-tab-item key="INFO">
                                <v-container>
                                    <v-row no-gutters>
                                        <v-col :cols="12">
                                            <span :class="{ title: true, limitTitle: this.selectable }">{{ value.name }}</span>
                                        </v-col>
                                        <v-col :cols="12">
                                            <span class="text-caption primary--text">
                                                {{ `${$t('Themen')}: ${value.numTopics}` }}
                                            </span>
                                        </v-col>
                                        <v-col :cols="12">
                                            <span class="text-caption grey--text">
                                                {{ `${$t('erstellt von')} ${value.createdBy.firstName} ${value.createdBy.lastName}` }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-expand-transition>
                                    <v-card flat v-if="showMoreInfo">
                                        <CourseInfo
                                            v-if="!isMyCourse"
                                            :selectable="this.selectable"
                                            :value="value"
                                            :durationInDays="showDurationInDays"
                                            :isMyCourse="isMyCourse"
                                        />
                                        <MyCourseInfo
                                            v-else
                                            :selectable="this.selectable"
                                            :value="value"
                                            :durationInDays="showDurationInDays"
                                            :isMyCourse="isMyCourse"
                                        />
                                    </v-card>
                                </v-expand-transition>
                            </v-tab-item>
                            <v-tab-item key="MATERIAL">
                                <div class="ck ck-content scroll" style="max-height: 20vh" v-html="materialSwitch(value.material)" @click.stop />
                                <MaterialDownloader :items="getMaterial(value)" />
                            </v-tab-item>
                            <v-tab-item key="CONTENT">
                                <div class="scroll" style="max-height: 20vh" @click.stop>
                                    <KnowledgeContent :contents="value.knowledgeContents" :selectable="false" v-model="computedSelectedKnowledgeContent" />
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions>
                <v-row align="center" justify="center">
                    <v-col cols="auto">
                        <v-btn v-show="computedShowInfoButton" icon @click.stop="toggleMoreInfo"
                            ><v-icon>{{ showInfoIcon }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-card>
</template>
<script>
import CourseMixin from '../../Mixins/CourseMixin';
import ImageLoader from '../../../../Generic/ImageLoader';
import TaxonomyTable from '../../TaxonomyTable';
import CourseAdminUser from '../../CourseAdminUser';
import KnowledgeContent from '../../../../KnowledgeContent/KnowledgeContentContent';
import AddUpdateCourse from '../../AddUpdateCourse';
import CourseInfo from './CourseInfo';
import MyCourseInfo from './MyCourseInfo';
import MaterialDownloader from '../../MaterialDownloader';

import moment from 'moment';

export default {
    name: 'course',
    components: {
        ImageLoader,
        TaxonomyTable,
        KnowledgeContent,
        CourseAdminUser,
        AddUpdateCourse,
        CourseInfo,
        MyCourseInfo,
        MaterialDownloader
    },
    mixins: [CourseMixin],
    data: () => ({
        operationType: 'UPDATE',
        showModal: false,
        showMoreInfo: false,
        courseAdmins: false,
        courseUsers: false,
        modalActive: 0,
        showPreviewDialog: false,
        materials: [],
        areMaterialsLoaded: false
    }),
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        isMyCourse: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Object,
            default: () => ({})
        },
        selectable: {
            type: Boolean,
            default: false
        },
        isGradingTable: {
            type: Boolean,
            default: false
        },
        selectedKnowledgeContent: {
            type: Array,
            default: () => []
        },
        isCourseManagerValue: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        modalActive(value) {
            if (value === 1 && !this.areMaterialsLoaded) {
                this.GET_COURSE_MATERIALS(this.value).then(() => (this.areMaterialsLoaded = true));
            }
        }
    },
    computed: {
        hasMaterial() {
            if (Object.keys(this.value).length > 0) {
                const materials = this.getMaterial(this.value);
                if (materials) {
                    return this.value.material !== '' || materials.length > 0;
                } else {
                    return this.value.material !== '';
                }
            }
            return false;
        },
        hasContentLinks() {
            if (Object.keys(this.value).length > 0) {
                return this.value.KnowledgeContents && this.value.KnowledgeContents.length > 0;
            }
            return false;
        },
        computedTabTitle() {
            if (this.value.typeName === null || this.value.typeName === '') {
                return this.$t('Kurs');
            }
            return this.value.typeName;
        },
        computedSelectedKnowledgeContent: {
            get() {
                return this.selectedKnowledgeContent;
            },
            set(value) {
                this.$emit('selectedKnowledgeContent', value);
            }
        },
        computedShowInfoButton() {
            return (this.modalActive === 0 && !this.isGradingTable) || (this.modalActive === 0 && this.isGradingTable && !this.$vuetify.breakpoint.xs);
        },
        computedHideBeforeStart() {
            return this.isMyCourse && this.value.hideBeforeStart && moment().format('YYYY-MM-DD') < this.value.startDate;
        },
        showDurationInDays() {
            if (this.isMyCourse && this.value.hideDurationInDays) {
                return 0;
            }
            return this.value.durationInDays;
        },
        computedGradingTable() {
            return this.isGradingTable && !this.selectable;
        },
        isCardSelected() {
            if (this.selected.hasOwnProperty('id') && this.value.hasOwnProperty('id')) {
                return this.selected.id === this.value.id;
            }
            return false;
        },
        cardStyle() {
            return {
                'elevation-12': this.isCardSelected,
                pointer: this.selectable
            };
        },
        showInfoIcon() {
            return this.showMoreInfo === false ? 'mdi-chevron-down' : 'mdi-chevron-up';
        },
        selectedCourse() {
            if (this.isAdmin) {
                return this.getSelectedAdminCourse;
            }
            return this.getSelectedAttendeeCourse;
        },
        isComparable() {
            return (
                this.selectedCourse !== null &&
                this.selectedCourse !== undefined &&
                this.value !== null &&
                this.value !== undefined &&
                this.value.hasOwnProperty('id') &&
                this.selectedCourse.hasOwnProperty('id')
            );
        },
        isSelected() {
            if (this.isComparable) {
                return this.value.id === this.selectedCourse.id;
            }
            return false;
        },
        picture() {
            if (this.value.hasOwnProperty('picture')) {
                if (this.value.picture.hasOwnProperty('fileURL')) {
                    if (this.value.picture.fileURL !== null && this.value.picture.fileURL !== undefined) {
                        return this.value.picture.fileURL;
                    }
                    return this.getDefaultCoursePicture;
                }
            }
            return this.getDefaultCoursePicture;
        }
    },
    methods: {
        update() {
            this.operationType = 'UPDATE';
            this.showModal = true;
        },
        toggleMoreInfo() {
            this.showMoreInfo = !this.showMoreInfo;
        },
        materialSwitch(content) {
            if (content === '') {
                return `<div class="text-xs-center" style="width:100%">${this.$t('Keine Materialien verfügbar')}</div>`;
            }
            return content;
        },
        openGradingTable() {
            this.$emit('gradingTable', true);
        },
        selectCard() {
            if (!this.computedHideBeforeStart) {
                this.$emit('selected', this.value);
            }
        },
        handleCourseSelection() {
            if (this.isComparable) {
                if (this.value.id === this.selectedCourse.id) {
                    this.$emit('input', {});
                } else {
                    this.$emit('input', this.value);
                }
            } else {
                this.$emit('input', this.value);
            }
        }
    }
};
</script>

<style scoped>
.scroll {
    overflow-y: auto;
}
.limitTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
